<template>
  <div class="row">
    <div class="col-6">
      <div class="all-log">
        <div style="position:absolute;left:2rem;top:-3rem;color:grey">
          <span @click="()=>{env='staging';getData()}" :class="{select:(env==='staging'),none:(env==='production')}">Staging</span><span> | </span>
          <span @click="()=>{env='production';getData()}" :class="{none:(env==='staging'),select:(env==='production')}">Production</span>
        </div>
        <input v-show="!live" v-model="search" class="input" @keyup.enter="submit" placeholder="search"/>
        <div style="position:absolute;right:4rem;top:1rem;color:grey" @click="getData" v-show="!live">Reload</div>
        <div style="position:absolute;right:4rem;top:1rem;color:grey" @click="getData" v-show="live">LIVE</div>
        <div v-if="!live" style="position:absolute;right:2rem;top:-3rem;color:black" @click="getLive">open live console</div>
        <div v-else style="position:absolute;right:2rem;top:-3rem;color:black" @click="getData">close live console</div>
        <div v-for="log in filteredLog" :key="log.timeStamp" class="log-item">
          <div @click="select=log">
            <div style="color:lightgreen">{{log.email?log.email:"non Auth"}}</div>
            <span
              style="color:crimson"
            >{{log.status?log.status:"third party api"}} ({{log.response?log.response:"no data available"}})<font style="color:lightgrey"> Screen: {{log.routeStack[0]}}</font></span>
            <div style="color:yellow;font-size:1rem">{{new Date(log.timeStamp)}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 all-log" style="padding:2rem">{{select}} <div v-if="select.crashLog" style="white-space:normal;margin:2rem;padding:2rem;background-color:darkred">{{JSON.parse(select.crashLog)}}</div></div>

   
  </div>
</template>

<script>
    import firebase from "firebase/app"
    import "firebase/database"
export default {
  data: () => ({
    filteredLog: [],
    allLog: [],
    select: {},
    search: "",
    env:"staging",
    live:false
  }),
  methods: {
    submit() {
      if (this.search === "refresh") this.getData();
      else if(this.search==="")this.filteredLog=this.allLog
      else
        this.filteredLog = this.allLog.filter(
          val =>
            val.email === this.search || val.status+"".toLowerCase() === this.search.toLowerCase()||val.routeStack[0].toLowerCase()===this.search.toLowerCase()
        );
    },
    getData() {
        this.live=false
      firebase
        .database()
        .ref(`mobile-log/${this.env}`)
        .orderByKey()
        .once("value", val => {
          let temp = [];
          val.forEach(child => {
            let item = child.val();
            temp.unshift(item);
          });
          this.allLog = temp;
          this.filteredLog = temp;
        });
    },
    getLive(){
        this.live=true
         firebase
        .database()
        .ref(`mobile-log/${this.env}`)
        .orderByKey()
        .on("value", val => {
          let temp = [];
          val.forEach(child => {
            let item = child.val();
            temp.unshift(item);
          });
          this.allLog = temp;
          this.filteredLog = temp;
         
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.all-log {
  width: 100%;

  background-color: #282c34;
  color: white;
  font-weight: bold;
  font-family: monospace;
  text-align: left;
  height: 70vh;
  overflow-y: scroll;
  white-space: pre;
  cursor: pointer;
}
.select{
    color:blue
}
input {
  width: 100%;
  height: 4rem;
  background-color: black;
  color: white;
  padding-left: 2rem;
  outline: none;
}
input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color:grey;
  opacity: 1; /* Firefox */
}
.log-item {
  padding: 2rem;
  transition: 0.5s;
  
}
.log-item:hover{
      background-color:#333333 ;
}
</style>